import React from 'react'
import InstagramSvg from 'svg/instagram'
import LinkedinSvg from 'svg/linkedin'
import YoutubeSvg from 'svg/youtube'

const svgs = {
	Instagram: <InstagramSvg />,
	LinkedIn: <LinkedinSvg />,
	YouTube: <YoutubeSvg />,
}

const SocialLinksSection = ({ links, largeOnMobile }) => (
	<div className="flex w-full justify-between">
		{links.map(({ address, label }) => (
			<a
				className={'accent-hover block ' + (largeOnMobile ? 'w-8' : 'w-6 lg:w-8')}
				href={address}
				target="_blank"
				title={label}
				rel="noreferrer"
				key={address}
			>
				{svgs[label]}
			</a>
		))}
	</div>
)

export default SocialLinksSection
